import { SelectedMenu, Widget } from 'rangeConfig/@types';
import { Connectors, CoreApi, ProductType } from '@inter-ikea-storageone/range';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { handlesTypeFilter, colorFilter } from 'rangeConfig/shared/filters/configFilters';
import addFrontLayout from 'rangeConfig/besta/behaviors/addFrontLayout';
import withDoorOpeningDirection from 'rangeConfig/shared/widgets/doorOpeningDirection/withDoorOpeningDirection';
import DoorOpeningDirectionWidget from 'rangeConfig/shared/widgets/doorOpeningDirection/DoorOpeningDirectionWidget';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import addHandleToFront from 'rangeConfig/besta/behaviors/addHandleToFront';
import IntegratedHandleWidget from 'rangeConfig/shared/widgets/IntegratedHandleWidget';
import {
  matchDrawerOpeningFunction,
  matchFrontLayoutToFrame
} from 'rangeConfig/besta/filters/selectedMenuProductFilters';
import {
  matchHandleSizeToFront,
  matchHandleTypeToFront
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import {
  hideIntegradeHandlesMessageSelectedMenu,
  isSelectedEntityDoor,
  isSelectedEntityDrawer,
  isSelectedEntityPushOpen
} from 'rangeConfig/shared/rules/hideMenuRules';
import removeHandleFromSelectedEntity from 'rangeConfig/shared/behaviors/removeHandleFromSelectedEntity';
import FrontOpeningFunctionToggleSelectedMenu from 'rangeConfig/besta/widgets/fronts/FrontOpeningFunctionToggleSelectedMenu';
import { getQPPImage } from 'products/utils';
import showHandlesDrillTemplateSheet from 'rangeConfig/shared/behaviors/showHandlesDrillTemplateSheet';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import replaceDoor from 'rangeConfig/shared/behaviors/replaceDoor';

const getMenuTitle = (coreApi: CoreApi) => {
  const isDrawerType = isSelectedEntityDrawer(coreApi);

  if (isDrawerType) {
    return 'storageone.selectedProductListCustomiseDrawer';
  } else {
    return 'storageone.selectedProductListCustomiseDoor';
  }
};

const selectedMenu = (): SelectedMenu => {
  return {
    menuTitle: getMenuTitle,
    behaviors: {
      productDeleted: [deleteProduct],
      selectedMenuExited: [showHandlesDrillTemplateSheet]
    },
    content: [
      {
        id: 'fronts-selected-menu-front-layout',
        title: 'storageone.frontLayoutTabTitle',
        cardsTitle: 'name',
        cardsSubtitle: '',
        productThumbToolTip: 'name',
        behaviors: {
          productDropped: [showDoors, addFrontLayout],
          productClicked: [showDoors, addFrontLayout]
        },
        productTypes: [ProductType.BESTA_FRONT_LAYOUT],
        productFilters: [matchFrontLayoutToFrame],
        hideInfoButton: true,
        hidePrice: true,
        alternativeSelectedProductList: true,
        sortOrder: [{ path: 'coreProductId' }]
      },
      {
        id: 'fronts-selected-menu-fronts',
        title: 'storageone.frontStyleTabTitle',
        productCardMainImage: getQPPImage,
        cardsTitle: 'name',
        cardsSubtitle: 'designText',
        behaviors: {
          productClicked: [showDoors, replaceDoor],
          productDropped: [showDoors, addProduct]
        },
        filters: [colorFilter],
        productFilters: [matchDrawerOpeningFunction]
      },
      {
        id: 'doorOpeningDirection',
        component: withDoorOpeningDirection(
          Connectors.LEFT_SERIES,
          Connectors.RIGHT_SERIES,
          Connectors.ATTACH_FRAME_2,
          Connectors.ATTACH_FRAME
        )(DoorOpeningDirectionWidget),
        title: 'storageone.doorOpeningDirectionTitle',
        hidden: isSelectedEntityDrawer
      } as Widget,
      {
        id: 'integratedHandleWidget',
        component: IntegratedHandleWidget,
        hidden: hideIntegradeHandlesMessageSelectedMenu
      },
      {
        id: 'fronts-selected-menu-opening-type',
        title: 'storageone.frontOpeningFunctionTabTitle',
        component: FrontOpeningFunctionToggleSelectedMenu,
        hidden: isSelectedEntityDoor
      },
      {
        id: 'fronts-selected-menu-handles',
        title: 'storageone.productListHandlesTitle',
        cardsTitle: 'name',
        cardsSubtitle: 'typeName, designText, communicatedSizeText',
        behaviors: {
          productDropped: [showDoors, addHandleToFront],
          productClicked: [showDoors, addHandleToFront]
        },
        hidden: isSelectedEntityPushOpen,
        productTypes: [ProductType.HANDLE, ProductType.KNOB, ProductType.EDGE_HANDLE],
        filters: [handlesTypeFilter, colorFilter],
        productFilters: [matchHandleSizeToFront, matchHandleTypeToFront],
        noneOption: {
          behaviors: { removeProducts: [removeHandleFromSelectedEntity] },
          selected: noProductsWithTypesForSelectedEntity([
            ProductType.HANDLE,
            ProductType.KNOB,
            ProductType.EDGE_HANDLE
          ]),
          title: 'storageone.productListNoHandlesOptionTitle',
          subtitle: 'storageone.productListNoHandlesOptionSubtitle'
        }
      },
      {
        id: 'fronts-selected-menu-handles-inline-message',
        title: 'storageone.productListHandlesTitle',
        component: withInlineMessage(
          'storageone.productListDisabledHandlePushOpenFronts',
          true
        )(CategoryAdditionalInlineMessage),
        hidden: (coreApi: CoreApi) => !isSelectedEntityPushOpen(coreApi)
      }
    ]
  };
};

export default selectedMenu;
